export const LEAVE_TYPES = {
  PAID: 'Paid Leave',
  UNPAID: 'Unpaid Leave',
};

export const ERROR_MESSAGES = {
  NO_LEAVE_TYPE: 'Please select "Paid" or "Unpaid" leave before submitting.',
  USER_PROFILE_MISSING: 'Failed to retrieve user details. Please try again.',
  QUARTERLY_LIMIT_EXCEEDED:
    'Quarterly paid leaves availed cannot exceed the quarterly paid limit.',
  FETCH_LEAVE_SUMMARY_FAILED: 'Failed to fetch leave summary.',
  SAVE_LEAVE_DETAILS_FAILED:
    'Failed to save leave details. Please try again later.',
  NO_DATA_AVAILABLE: 'No data available for the selected vendor.',
  EMPLOYEE_ID_MISSING: 'Employee ID is missing',
  MONTH_YEAR_MISSING: 'Month and year are missing',
  WEEKEND_LEAVE_NOT_ALLOWED: 'Cannot apply leave on weekends.',
  NO_DATE_SELECTED: 'Please select at least one date before submitting.',
  WEEKEND_LEAVE_PROHIBITED: 'Leave cannot be applied for Saturdays or Sundays.',
  DATE_ALREADY_MARKED: 'Leave cannot be applied for public holidays or existing leaves.',
};

export const SUMMARY_KEYS = {
  TOTAL_LEAVES: 'Total Leaves',
  PAID_LEAVES: 'Paid Leaves',
  UNPAID_LEAVES: 'Unpaid Leaves',
  QUARTERLY_LIMIT: 'Quarterly Limit',
  QUARTERLY_AVAILED: 'Quarterly Availed',
};

export const SUMMARY_KEYS_ATTENDANCE = {
  OFFICE_DAYS: 'Office Days',
  REMOTE_DAYS: 'Remote Days',
  ABSENT_DAYS: 'Absent Days',
  HOLIDAY_DAYS: 'Holiday Dates',
};
